import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e74ab66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-font" }
const _hoisted_2 = { class: "mb-4 button-container" }


import { defineComponent, ref, onMounted } from 'vue'
import { getI18n, isChinese, apiFetchData } from '../utils'
import CarrierCard from '../components/CarrierCard.vue'

const __default__ = defineComponent({
  name: 'CarrierCardView'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const refCarrier = ref([])
const refFilter = ref('')
let carrierList = []
const refFilterItems = ref([])

function fitlerCarrier () {
  console.info('fitlerCarrier', refFilter)
  const lowerStr = refFilter.value.toLowerCase() // 转换为小写
  refCarrier.value = []
  for (const item of carrierList) {
    console.info(item.region, lowerStr)
    if (item.region_name.toLowerCase().includes(lowerStr) || item.continent.toLowerCase().includes(lowerStr)) {
      refCarrier.value.push(item)
    }
  }
}

function filter (item) {
  if (item === 'All' || item === '全部') {
    refFilter.value = ''
  } else {
    refFilter.value = item
  }
  fitlerCarrier()
}
onMounted(async () => {
  let url = '/h5/v1/carrier/query-cc?language='
  if (isChinese()) {
    url += 'zh_CN'
    refFilterItems.value = ['全部', '港澳台', '亚洲', '欧洲', '美洲', '非洲', '大洋洲']
  } else {
    url += 'en_US'
    refFilterItems.value = ['All', 'Hong Kong, Macao, Taiwan', 'Asia', 'Europe', 'America', 'Africa', 'Oceania']
  }
  apiFetchData(url)
    .then(data => {
      if (data !== null && data !== undefined) {
        carrierList = data.data
        fitlerCarrier()
      }
    })
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "data-radius main",
    style: _normalizeStyle([{borderRadius: '4px'}, {"width":"100%"}])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(getI18n)('运行商里列表','Carrier List')), 1),
    _createVNode(_component_el_row, {
      align: "middle",
      class: "el-row-margin"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          style: {"display":"flex","justify-content":"flex-end"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tag, { type: "success" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('过滤器', 'Filter')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: refFilter.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refFilter).value = $event)),
              style: {"width":"100%","margin-left":"10px"},
              placeholder: "Please input",
              onInput: fitlerCarrier
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refFilterItems.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_button, {
          key: item,
          onClick: ($event: any) => (filter(item))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refCarrier.value, (carrier) => {
      return (_openBlock(), _createBlock(CarrierCard, {
        key: carrier.region_name,
        regionName: carrier.region_name,
        continent: carrier.continent,
        carrier: carrier.carrier,
        apn: carrier.apn,
        supportTiktok: carrier.support_tiktok
      }, null, 8, ["regionName", "continent", "carrier", "apn", "supportTiktok"]))
    }), 128))
  ]))
}
}

})